import React from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import { OrganizationFragment } from 'components/shared/fragments';

const CurrentOrganizationStateContext = React.createContext<any>(undefined);
const CurrentOrganizationDispatchContext = React.createContext<
  ((orgId: string | null) => void) | undefined
>(undefined);

function CurrentOrganizationProvider({ children }: any) {
  const [organizationId, setOrganizationId] = React.useState<string | null>(
    null,
  );
  const client = useApolloClient();

  const organization =
    organizationId &&
    client.readFragment({
      id: `Organization:${organizationId}`,
      fragment: OrganizationFragment,
      fragmentName: 'Organization',
    });

  return (
    <CurrentOrganizationStateContext.Provider value={organization}>
      <CurrentOrganizationDispatchContext.Provider value={setOrganizationId}>
        {children}
      </CurrentOrganizationDispatchContext.Provider>
    </CurrentOrganizationStateContext.Provider>
  );
}

function useCurrentOrganization() {
  const context = React.useContext(CurrentOrganizationStateContext);

  if (context === undefined) {
    throw new Error(
      'useCurrentOrganization must be used within a CurrentOrganizationProvider',
    );
  }

  return context;
}

function useCurrentOrganizationDispatch() {
  const context = React.useContext(CurrentOrganizationDispatchContext);

  if (context === undefined) {
    throw new Error(
      'useCurrentOrganizationDispatch must be used within a CurrentOrganizationProvider',
    );
  }

  return context;
}

export {
  CurrentOrganizationProvider,
  CurrentOrganizationStateContext,
  useCurrentOrganization,
  useCurrentOrganizationDispatch,
};
